export const EXPERIMENTS = {
  freeTrial: process.env.REACT_APP_FREE_TRIAL_EXPERIMENT_ID,
  applePay: process.env.REACT_APP_APPLE_PAY_EXPERIMENT_ID,
  pricing: process.env.REACT_APP_PRICING_EXPERIMENT_ID,
  freemium: process.env.REACT_APP_FREEMIUM_EXPERIMENT_ID,
}

export const VARIANTS = {
  control: 'control',
  treatment: 'treatment',
  off: 'off',
}
